import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline} from "gsap";
import {HorribleHeroes} from "../../HorribleHeroes";
import {HorribleHeroesParsedGameData} from "../../server/data/HorribleHeroesParsedGameData";


export class HorribleHeroesNearWin implements GameRoundPresentation {
    private readonly _reelId: number;
    private _duration: number;


    /**
     * @constructs
     * @param reelId
     * @param duration
     */
    constructor(reelId: number, duration: number) {
        this._reelId = reelId;
        this._duration = Math.max(HorribleHeroes.timelineReelsController.getReelConfig(this._reelId).nearWinDuration, duration);
        //Because of how the reels work now, this duration needs to be longer than the configured value  REEL_NEAR_WIN_STOP_DELAY in game config. Set the config to 0 if you want to control it in with this duration.
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: HorribleHeroesParsedGameData): Timeline | null {
        if (!data.wasFeatureBuy && data.nearWinReels[this._reelId]) {
            if (data.nearWinReels[this._reelId] && this.calculateScatterCount(data) < 2) {
                // #194
                // #540 -> This anticipation can only be true for reel id 2, 3 and 4.
                // # 540 -> And the durations are fixed for these reel ids not as per the count of how many reels are true(say the anticipation starts from reel id 3) for this anticipation.
                if (this._reelId === 2) {
                    this._duration = 0.4;
                } else if (this._reelId === 3) {
                    this._duration = 0.6;
                } else {
                    this._duration = 0.8;
                }
            } else if (data.nearWinReels[this._reelId]) {
                this._duration = 3;
                //default anticipation duration
                //#267
            }
            return HorribleHeroes.timelineReelsController.startNearWin(this._reelId, this._duration);
        }
        return null;
    }

    private calculateScatterCount(data: HorribleHeroesParsedGameData) {
        let scatterCount = 0;
        data.scatterPositions!.forEach((sctterpos: number, index: number) => {
            if (index < this._reelId) {
                if (sctterpos > -1) {
                    scatterCount++;
                }
            }
        });
        return scatterCount;
    }

}